module.exports = __webpack_public_path__ + "img/71.ad19fc90.jpg";